import service from '@/utils/request'

export function getWebViewConfig(config = {}) {
    return service.get('/api/v1/webViewConfig/', config)
}

export function getNotification(config = {}) {
    return service.get('/api/v1/notification/', config)
}

export function markAppDownloadLog() {
    return service.get('/api/v1/app-download-log/')
}
